import { vestingTypeApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const BORROWER_VESTING_TYPES_ACTION_TYPE = createNamedActions('borrowerVestingTypes', {
  GET_TYPES: 'GET_TYPES',
  CREATE_TYPE: 'CREATE_TYPE',
  EDIT_TYPE: 'EDIT_TYPE',
  DELETE_TYPE: 'DELETE_TYPE',
});

const borrowerVestingTypesSchema = new schema.Entity('data', {}, { idAttribute: 'vestingTypeId' });

export const getBorrowerVestingTypesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await vestingTypeApi.getTypes(params);

  return dispatch({
    type: BORROWER_VESTING_TYPES_ACTION_TYPE.GET_TYPES,
    payload: normalize(data, [borrowerVestingTypesSchema]).entities.data,
  });
});

export const createBorrowerVestingTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await vestingTypeApi.createType(params);

  return dispatch({
    type: BORROWER_VESTING_TYPES_ACTION_TYPE.CREATE_TYPE,
    payload: data,
  });
});

export const editBorrowerVestingTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await vestingTypeApi.editType(params);

  return dispatch({
    type: BORROWER_VESTING_TYPES_ACTION_TYPE.EDIT_TYPE,
    payload: data,
  });
});

export const deleteBorrowerVestingTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await vestingTypeApi.deleteType(params);

  return dispatch({
    type: BORROWER_VESTING_TYPES_ACTION_TYPE.DELETE_TYPE,
    payload: data,
    meta: params,
  });
});
